import {
  GET_FORMS,
  GET_FORMS_BY_IDS,
  GET_FORM_JSON,
  CLEAR_FORM,
  DELETE_FORMS,
  UPDATE_FORM,
  UPDATE_CURRENT_FORM,
  SET_CURRENT_FORM_TITLE
} from "../constants/action-types";
import Axios from "axios";

import { getApiConfig } from "../../config/apiConfig";
import { adalApiFetch } from "../../config/azureConfig";
const API_CONFIG = getApiConfig();

/*
  Check that we can parse the string as JSON.
*/
function parseJSON(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return null;
  }
}
/*
  Get form.
*/
export const getForms = callback => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/forms`, {
    method: "get"
  })
    .then(res => {
      dispatch({
        type: GET_FORMS,
        payload: res.data
      });

      callback(true);
    })
    .catch(error => {
      console.log("Exception occurred", error);
      callback(false);
    });
};

/*
  Create form.
*/
export const createForm = (data, callback) => dispatch => {
  const headers = { "Content-Type": "application/json" };

  const parsedData = parseJSON(data);

  if (parsedData !== null) {
    adalApiFetch(Axios, `${API_CONFIG.URL}/forms`, {
      method: "post",
      data: { formData: parsedData },
      headers
    })
      .then(res => {
        callback(true);
      })
      .catch(error => {
        console.log("Exception occurred", error);
        callback(false);
      });
  } else {
    callback(false);
  }
};

/*
  Update form.
*/
export const updateForm = (data, callback) => dispatch => {
  const headers = { "Content-Type": "application/json" };

  const parsedData = parseJSON(data);

  if (parsedData !== null) {
    adalApiFetch(Axios, `${API_CONFIG.URL}/forms`, {
      method: "put",
      data: { formData: parsedData },
      headers
    })
      .then(res => {
        dispatch({
          type: UPDATE_FORM,
          payload: data
        });

        callback(true);
      })
      .catch(error => {
        console.log("Exception occurred", error);
        callback(false);
      });
  } else {
    callback(false);
  }
};

/*
  Delete form.
*/
export const deleteForms = (data, callback) => dispatch => {
  const headers = { "Content-Type": "application/json" };

  adalApiFetch(Axios, `${API_CONFIG.URL}/forms`, {
    method: "delete",
    data: data,
    headers
  })
    .then(res => {
      dispatch({
        type: DELETE_FORMS,
        payload: data
      });
      callback(true);
    })
    .catch(error => {
      console.log("Exception occurred", error);
      callback(false);
    });
};

/* 
  Get forms by ids.
*/
export const getFormsForIds = (formIds, callback) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/forms?forIds=true`, {
    method: "post",
    data: formIds
  })
    .then(res => {
      const data = res.data;

      dispatch({
        type: GET_FORMS_BY_IDS,
        payload: data
      });

      callback(true);
    })
    .catch(error => {
      console.log(`Exception Occurred: ${error}`);
      callback(false);
    });
};

export const getFormJson = (formOutlineId, callback) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/forms/${formOutlineId}`, {
    method: "get"
  })
    .then(res => {
      const data = res.data;

      dispatch({
        type: GET_FORM_JSON,
        payload: data
      });

      callback(true);
    })
    .catch(error => {
      console.log(`Exception Occurred: ${error}`);
      callback(false);
    });
};

export const clearForm = callback => dispatch => {
  dispatch({
    type: CLEAR_FORM
  });

  callback(true);
};

export const updateCurrentForm = (form, callback) => dispatch => {
  dispatch({
    type: UPDATE_CURRENT_FORM,
    payload: form
  });

  callback(true)
}

export const setCurrentFormTitle = (title, callback) => dispatch => {
  dispatch({
    type: SET_CURRENT_FORM_TITLE,
    payload: title
  });

  callback(true)
}